import { BirdviewTrend } from '../DashboardBirdview.constants.charts'

// A growing backlog points up and reads as a warning.
export const BIRDVIEW_FLOW_TREND_HEADLINE_KEY = {
  [BirdviewTrend.Down]: 'DashboardBirdview.ChartBacklogShrinkingKey',
  [BirdviewTrend.Flat]: 'DashboardBirdview.ChartBacklogSteadyKey',
  [BirdviewTrend.Up]: 'DashboardBirdview.ChartBacklogGrowingKey',
}

export const BIRDVIEW_FLOW_CHART_GRID_PROPS = {
  stroke: 'var(--color-border)',
  vertical: false,
}
